import { reduxForm } from 'redux-form';

import AuthorizationForm from './AuthorizationForm';

export default reduxForm({ form: 'authorizationForm' })(AuthorizationForm);
